<template>
  <div>
    <el-card class="voucher-card" shadow="nerver">
      <!-- 页头 -->
      <div style="font-size: 20px">
        <span class="el-icon-info">公司信息</span>
      </div>
      <!-- 账号类型 -->
      <div style="margin-top: 50px; font-size: 15px">
        <span style="padding-right: 30px">账号类型:</span>年会员/达人号
      </div>
      <!-- 公司名称 -->
      <el-divider content-position="right">
        <el-link icon="el-icon-edit" @click="changeCompany">编辑</el-link>
      </el-divider>
      <div style="font-size: 15px">
        <span style="padding-right: 30px">公司名称:</span>南京速至所想
      </div>
      <!-- 联系电话 -->
      <el-divider content-position="right">
        <el-link icon="el-icon-edit">编辑</el-link>
      </el-divider>
      <div style="font-size: 15px">
        <span style="padding-right: 30px">公司电话:</span>13701584465
      </div>
      <!-- 负责人 -->
      <el-divider content-position="right">
        <el-link icon="el-icon-edit">编辑</el-link>
      </el-divider>
      <div style="font-size: 15px">
        <span style="padding-right: 47px">联系人:</span>Allen
      </div>
      <!-- 确认单的头部 -->

      <div class="voucher-header">
        <el-divider> <i class="el-icon-tickets"></i> 确认单相关 </el-divider>
        <div style="font-size: 15px; margin-bottom: 20px">
          <span>确认单头部展示:</span>
        </div>
        <!-- 头部编辑器 -->
        <!-- <el-upload class="avatar-uploader" :action="serverUrl" name="img"></el-upload> -->
        <!-- element upload -->
        <traver-editor></traver-editor>
      </div>
      <!-- 确认单的底部 -->
      <div style="font-size: 15px">
        <span>确认单尾部展示:</span>
      </div>
      <div class="voucher-footer">
        <!-- 尾部编辑器 -->
        <traver-editor></traver-editor>
      </div>
    </el-card>
  </div>
</template>

<script>
import editor from "../../components/common/editor/editorV1";
export default {
  components: { "traver-editor": editor },
  name: "Companyconfig",
  data() {
    return {
      header_introduce: "",
      footer_introduce: "hhhhh",
    };
  },
  methods: {
    // 提交公司信息
    changeCompany() {
      this.$prompt("请输入公司名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {});
    },
  },
};
</script>

<style>
.voucher-card {
  height: auto;
  /* padding: 0 10px; */
}

.voucher-header {
  margin: 100px 0;
  width: 80%;
}

.voucher-footer {
  margin: 20px 0;
  width: 80%;
}

.button-voucher {
  margin: 10px !important;
  float: right;
}

.ql-editor {
  min-height: 200px;
}
</style>